const CONTACT_FORM_EVENT = {
  event: 'generate_lead',
  form_name: 'contact us',
};

export const emitDatalayerEvent = (): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(CONTACT_FORM_EVENT);
  }
};
